{
  "error-unable-to-create": "Unable to create financial goal. Please try again later",
  "error-unable-to-delete": "Unable to delete financial goal. Please try again later",
  "error-unable-to-update": "Unable to update financial goal. Please try again later",
  "error-unable-to-reorder": "Unable to reorder financial goal. Please try again later",
  "edit-goals": "Edit Goals"
}
